import { ShippingCarriers } from "../shippingCarriers";
import { ShippingService } from "../shippingRates.types";
import { getPricesWithVAT } from "../utils";



export const leboncoin_mondialRelay: ShippingService = {
  serviceCode: 'leboncoin_mondialRelay',
  description: 'Buying on Leboncoin, cost is paid externally by customer',
  deliveryType: 'pickup',
  carrier: ShippingCarriers.mondial_relay,
  appliesVolumetricWeight: false,
  maxDimensions: (size1: number, size2: number, size3: number, weight: number) => {
    if (weight >= 30000) {
        return { isValid: false, errorMessage: 'Max weight exceeded (30kg).' };
    }
    const calculation = size1 + size2 + size3;
    if (calculation > 150) {
        return { isValid: false, errorMessage: 'Max dimensions exceeded (150cm). Calculation is Length + Width + Height' };
    }
    return { isValid: true, errorMessage: '' };
  },
  conditions: {
    orderPlatform: 'leboncoin',
  },
  ratesByDestination: [
    {
      destinations: ['FR'],
      rates: [
        {
          minWeight: 0,
          maxWeight: 500,
          ...getPricesWithVAT(2.49),
        },
        {
          minWeight: 500,
          maxWeight: 1000,
          ...getPricesWithVAT(2.99),
        },
        {
          minWeight: 1000,
          maxWeight: 2000,
          ...getPricesWithVAT(4.99),
        },
        {
          minWeight: 2000,
          maxWeight: 5000,
          ...getPricesWithVAT(6.49),
        },
        {
          minWeight: 5000,
          maxWeight: 10000,
          ...getPricesWithVAT(10.99),
        },
        {
          minWeight: 10000,
          maxWeight: 30000,
          ...getPricesWithVAT(15.99),
        },
      ],
    },
  ],
}